@if ($swimlane(); as swimlane) {
  @if (swimlane.alwaysShowSwimlaneHeader || $showHeader()) {

    @let swimlaneHeaderTemplate = $host().swimlaneHeaderTemplate();
    @let swimlaneItemCount = $host().laneItemCount(swimlane);

    <!-- {} -->

    <!-- Collapse lives on the CHEVRON, not the whole bar: the header body is a projected template
         whose own tap opens the record the lane groups by, and a click handler spanning the bar would
         swallow it. The default (untemplated) header keeps the whole bar clickable, since it projects
         nothing that could want the gesture. -->
    <div class="swimlane-item-header" (click)="swimlaneHeaderTemplate ? null : onLaneToggle(swimlane)" [class.expanded]="!swimlane.collapsed" [class.swimlane-default-content]="!swimlaneHeaderTemplate">
      <div class="chevron" (click)="onLaneToggle(swimlane); $event.stopPropagation()">
        <i class="fa" [class.fa-chevron-up]="!swimlane.collapsed" [class.fa-chevron-down]="!!swimlane.collapsed"></i>
      </div>
      <div class="content">
        @if (swimlaneHeaderTemplate) {
          <ng-container [ngTemplateOutlet]="swimlaneHeaderTemplate" [ngTemplateOutletContext]="{ item: swimlane }" />
        } @else {
          <div class="swimlane-title">{{ swimlane.name }}</div>
          <div class="swimlane-count">({{ swimlaneItemCount }} Job{{ swimlaneItemCount === 1 ? '' : 's' }})</div>
          }
      </div>
    </div>
    }

    @if (!swimlane.collapsed) {
      <div class="swimlane">
        @if ($host().showSwimlaneColumn()) {
          <div class="swimlane-column">
            @let item = swimlane.data;
          <div class="kanban-item" wbPointerGestures (tap)="$host().onItemTapped(item, true)" (doubleTap)="$host().onItemDblClicked({ item, isSwimlaneItem: true })" (longPress)="$host().onItemDblClicked({ item, isSwimlaneItem: true })" [class.active]="$host().isSelected(item, $host().selectedItem())">
            @if ($host().swimlaneColumnTemplate(); as swimlaneColumnTemplate) {
              <ng-container [ngTemplateOutlet]="swimlaneColumnTemplate" [ngTemplateOutletContext]="{ item, utility: $host().colorUtility }" />
            }
          </div>
      </div>
    }

    @for (column of swimlane.columns; track column.key) {
      <kanban-column class="column" [class.empty]="!column.hasItems" [class.collapsed]="!!column.collapsed" [swimlane]="swimlane" [column]="column" [host]="$host()" />
    }
    </div>
  }
  }